import { SliderTemplateConfig } from '../models/slider-types-models';

import { MediasPublicConstants } from '@features/products/medias';
import { ImageType, Position, ProductViewPlaceValue } from '@shared/product/models';

const newConfig = {
    clickable: true,
    location: MediasPublicConstants.PublicMediaLocationType.category_page,
    place: ProductViewPlaceValue.PRODUCT_GRID,
};

const COMMON_SLIDER_CONFIG: SliderTemplateConfig = {
    templateConfigurations: {
        ...newConfig,
        imageType: undefined,
        showDescription: false,
        showTags: false,
        showName: false,
        showPrice: false,
        showQuickly: false,
        textPosition: Position.bottom,
        showColors: false,
        showDiscount: false,
        showMadeInExclusive: false,
        media: {
            widthVW: '20vw',
            ratio: '3-4',
        },
    },
    slidesPerView: 'auto',
    centerInsufficientSlides: false,
    navigation: true,
    skLoad: '',
    skLoadMobile: '',
    spaceBetween: {
        desktopLarge: 0,
        desktop: 0,
    },
    needReload: true,
    hedeScrollBar: true,
    classes: {
        parent: ['grid-new'],
        desktop: [''],
        mobile: ['mobile-center-monoprod'],
        ssr: [''],
        swiper: ['swiper-width'],
        navigationArrows: ['swiper-navigation-arrows-container'],
        product: ['full-size'],
        productMobile: ['full-size', 'p-view'],
    },
};

const templateConfigurations = {
    NCB: (): SliderTemplateConfig => {
        return {
            ...COMMON_SLIDER_CONFIG,
            templateConfigurations: {
                ...newConfig,
                imageType: undefined,
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                textPosition: Position.bottom,
                showColors: true,
                showDiscount: true,
                showMadeInExclusive: true,
                media: {
                    widthVW: '20vw',
                    ratio: '3-4',
                },
            },
            slidesPerView: 4,
            spaceBetween: {
                desktopLarge: 20,
                desktop: 20,
            },
        };
    },
    LS1: (): SliderTemplateConfig => {
        return {
            ...COMMON_SLIDER_CONFIG,
            templateConfigurations: {
                ...newConfig,
                imageType: undefined,
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                textPosition: Position.bottom,
                showColors: true,
                showDiscount: true,
                showMadeInExclusive: true,
                media: {
                    widthVW: '40vw',
                    ratio: '9-20',
                },
            },
            slidesPerView: 5,
        };
    },
    LS2: (): SliderTemplateConfig => {
        return {
            ...COMMON_SLIDER_CONFIG,
            templateConfigurations: {
                ...newConfig,
                imageType: undefined,
                showDescription: false,
                showTags: true,
                showName: true,
                showPrice: true,
                showQuickly: true,
                textPosition: Position.bottom,
                showColors: true,
                showDiscount: true,
                showMadeInExclusive: true,
                media: {
                    widthVW: '40vw',
                    ratio: 'full',
                },
            },
            navigation: false,
        };
    },
    NSLA: (): SliderTemplateConfig => {
        return {
            ...COMMON_SLIDER_CONFIG,
            templateConfigurations: {
                ...newConfig,
                imageType: ImageType.double,
                showDescription: false,
                showTags: false,
                showName: false,
                showPrice: false,
                showQuickly: false,
                showDetails: false,
                textPosition: Position.none,
                showColors: false,
                showDiscount: false,
                showMadeInExclusive: false,
                media: {
                    widthVW: '100vw',
                    ratio: '3-4',
                    showWaterMark: false,
                },
            },
            navigation: false,
        };
    },
};

export function getSliderTemplateConfig(templateName: string): SliderTemplateConfig {
    return templateConfigurations[templateName]();
}
